import { Injector, Pipe, PipeTransform } from '@angular/core';
import { formatDateWithSuffix } from '../helper';
import { chartFilters } from '../interfaces';

@Pipe({
    name: 'chartDateFilter',
    standalone: true
})
export class ChartDateFilterPipe implements PipeTransform {
    constructor (private injector: Injector) {}

    transform(input: chartFilters): {fromDate: string, toDate: string} {
        return {fromDate: formatDateWithSuffix(input.dateRange?.start, this.injector), toDate: formatDateWithSuffix(input.dateRange?.end, this.injector)}
    }
}